import React from 'react';

import './styles/contact.css';

const ContactInput = () => (
  <section className="subtitle">
    <form id="myForm" action="https://formspree.io/f/xgebkzdk" method="POST">
      <input
        id="name"
        type="text"
        name="username"
        maxLength="30"
        placeholder="Enter Name"
        required
      />
      <input
        id="email"
        type="email"
        name="email"
        placeholder="johndoe@gmail.com"
        required
      />
      <textarea name="message" id="message" placeholder="Enter text here..." maxLength="500" required />
      <button type="submit" id="send-btn">Send</button>
      <p id="errorMessage" className="errorStyle errorOutput" />
    </form>
  </section>
);

export default ContactInput;
